<template>
<div class="layout">
    <TheTop />
    <TheHeaderBox :title='orgName' />
    <TheNav />
    <div class="layout-main">
        <router-view />
    </div>
    <TheFooter />
</div>
</template>

<script>
import TheTop from "@/components/TheTop";
import TheHeaderBox from "@/components/TheHeaderBox";
import TheNav from "@/components/TheNav";
import TheFooter from "@/components/TheFooter";
export default {
    components: {
        TheTop,
        TheHeaderBox,
        TheNav,
        TheFooter,
    },
    data() {
        return {
            keyword: ''
        }
    },
    computed: {
        orgName() {
            return this.$store.getters.orgName
        }
    },

}
</script>

<style lang="scss" scoped>
.layout {
    min-height: 100%;
    position: relative;
    padding-bottom: 84px;

        .layout-main {
            // min-height: 752px;
            position: relative;
            z-index: 1;
        }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/index.vue